import { themeColors } from '@/config/theme'

// 辅助函数：将十六进制颜色转换为RGB
const hexToRgb = (hex) => {
  // 移除#号
  hex = hex.replace('#', '')
  
  // 解析RGB值
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  
  return `${r}, ${g}, ${b}`
}

const state = {
  currentTheme: themeColors[0] // 默认使用第一个主题
}

const mutations = {
  SET_THEME(state, theme) {
    state.currentTheme = theme
    // 更新CSS变量
    document.documentElement.style.setProperty('--primary-color', theme.primary)
    document.documentElement.style.setProperty('--secondary-color', theme.secondary)
    document.documentElement.style.setProperty('--gradient-color', theme.gradient)
    
    // 更新菜单和导航相关变量
    document.documentElement.style.setProperty('--menu-active-bg', `rgba(${hexToRgb(theme.primary)}, 0.1)`)
    document.documentElement.style.setProperty('--menu-hover-bg', `rgba(${hexToRgb(theme.primary)}, 0.05)`)
    document.documentElement.style.setProperty('--menu-active-indicator', theme.primary)
    document.documentElement.style.setProperty('--menu-active-text', theme.primary)
    
    // 更新按钮和交互元素
    document.documentElement.style.setProperty('--button-primary-bg', theme.primary)
    document.documentElement.style.setProperty('--button-primary-hover', `rgba(${hexToRgb(theme.primary)}, 0.8)`)
    
    // 更新通知和徽章
    document.documentElement.style.setProperty('--badge-bg', `linear-gradient(135deg, ${theme.primary}, ${theme.secondary})`)
    
    // 更新卡片和容器相关变量
    document.documentElement.style.setProperty('--card-border', `1px solid rgba(${hexToRgb(theme.primary)}, 0.1)`)
    
    // 保存到localStorage以便刷新后保持主题
    localStorage.setItem('currentTheme', JSON.stringify(theme))
  }
}

const actions = {
  // 切换主题
  changeTheme({ commit }, theme) {
    commit('SET_THEME', theme)
  }
}

const getters = {
  currentTheme: state => state.currentTheme
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}